import React from "react";

const Loading = () => {
  return (
    <>
      <div className="preloader">
        <div className="loader">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
        </div>
      </div>
    </>
  );
};

export default Loading;
